export function packCheckState(
  packTrackIds: string[],
  selected: Set<string>
): 'all' | 'some' | 'none' {
  if (packTrackIds.length === 0) return 'none';

  let selectedCount = 0;
  for (const id of packTrackIds) {
    if (selected.has(id)) selectedCount++;
  }

  if (selectedCount === 0) return 'none';
  if (selectedCount === packTrackIds.length) return 'all';
  return 'some';
}

export function packCheckboxValue(
  state: 'all' | 'some' | 'none',
): boolean | 'indeterminate' {
  switch (state) {
    case 'all':
      return true;
    case 'none':
      return false;
    case 'some':
      return 'indeterminate';
    default: {
      const _exhaustive: never = state;
      return _exhaustive;
    }
  }
}

export function toggleExclusiveId(current: string | null, id: string): string | null {
  return current === id ? null : id;
}

export function initialExpandedPackId(
  packs: Array<{ id: string; trackIds: string[] }>,
  selected: Set<string>,
): string | null {
  const withSelected = packs.find((pack) => packCheckState(pack.trackIds, selected) !== 'none');
  if (withSelected) return withSelected.id;
  return packs[0]?.id ?? null;
}

export function applyPackBulk(
  packTrackIds: string[],
  selected: Set<string>,
  nextChecked: boolean
): Set<string> {
  const next = new Set(selected);
  if (nextChecked) {
    for (const id of packTrackIds) next.add(id);
  } else {
    for (const id of packTrackIds) next.delete(id);
  }
  return next;
}
